import Vue from 'vue'
import Router from 'vue-router'
import types from '@/store/types'
import store from '@/store'
import { Auth } from '@/api'
import { Notification, Message } from 'element-ui'

const Mgmt = () => import('@/components/layout/Mgmt')
const Login = () => import('@/views/Login')
const Home = () => import('@/views/Home')
const House = () => import('@/views/House/House')
const HouseEdit = () => import('@/views/House/HouseEdit')
const HouseDetail = () => import('@/views/House/HouseDetail')
const Staff = () => import('@/views/Staff')
const My = () => import('@/views/My')
const NotFound = () => import('@/components/NotFound')
const Resident = () => import('@/views/Resident/Resident')
const ResidentEdit = () => import('@/views/Resident/ResidentEdit')
const ResidentDetail = () => import('@/views/Resident/ResidentDetail')
const Lock = () => import('@/views/Lock')
const HouseKeepPerm = () => import('@/views/Staff/HouseKeepPerm')
const SharedRent = () => import('@/views/SharedRent')
const EntireRent = () => import('@/views/EntireRent')
const Announcement = () => import('@/views/Announcement')
const Suggestion = () => import('@/views/Suggestion')
const SuggestionDetail = () => import('@/views/Suggestion/suggestionDetail')
const Repair = () => import('@/views/Repair')
const RepairDetail = () => import('@/views/Repair/RepairDetail')
const Visitor = () => import('@/views/Visitor')
const OperationRecords = () => import('@/views/OperationRecords')

Vue.use(Router)

let router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/mgmt',
      component: Mgmt,
      children: [
        {
          path: 'home',
          component: Home
        },
        {
          path: 'houses',
          component: House,
          meta: { requiresPerm: ['room_mgmt', 'room_view'] }
        },
        {
          path: 'house/create',
          component: HouseEdit,
          meta: { requiresPerm: ['room_mgmt'] }
        },
        {
          path: 'house/:id/detail',
          component: HouseDetail,
          meta: { requiresPerm: ['room_mgmt', 'room_view'] }
        },
        {
          path: 'house/:id/edit',
          component: HouseEdit,
          meta: { requiresPerm: ['room_mgmt'] }
        },
        {
          path: 'resident',
          component: Resident,
          meta: { requiresPerm: ['resident_mgmt', 'resident_view'] }
        },
        {
          path: 'resident/create',
          component: ResidentEdit,
          meta: { requiresPerm: ['resident_mgmt'] }
        },
        {
          path: 'resident/:id/edit',
          component: ResidentEdit,
          meta: { requiresPerm: ['resident_mgmt'] }
        },
        {
          path: 'resident/:id/detail',
          component: ResidentDetail,
          meta: { requiresPerm: ['resident_mgmt', 'resident_view'] }
        },
        {
          path: 'staff',
          component: Staff,
          meta: { requiresPerm: ['org_mgmt', 'org_view'] }
        },
        {
          path: 'operationRecords',
          component: OperationRecords,
          meta: { requiresPerm: ['org_mgmt', 'org_view'] }
        },
        {
          path: 'houseKeeperPerm/:id',
          component: HouseKeepPerm
        },
        {
          path: 'locks',
          component: Lock
        },
        {
          path: 'announcement',
          component: Announcement,
          meta: {requiresPerm: ['community_view', 'community_mgmt']}
        },
        {
          path: 'my',
          name: 'my',
          component: My
        },
        {
          path: 'sharedRent',
          component: SharedRent,
          meta: { requiresPerm: ['room_mgmt', 'room_view'] }
        },
        {
          path: 'entireRent',
          component: EntireRent,
          meta: { requiresPerm: ['room_mgmt', 'room_view'] }
        },
        {
          path: 'suggestion',
          component: Suggestion,
          meta: { requiresPerm: ['community_view', 'community_mgmt'] }
        },
        {
          path: 'suggestion/:id/detail',
          component: SuggestionDetail,
          meta: { requiresPerm: ['community_view'] }
        },
        {
          path: 'repair',
          component: Repair,
          meta: { requiresPerm: ['service_mgmt', 'service_view'] }
        },
        {
          path: 'repair/:id/detail',
          component: RepairDetail,
          meta: { requiresPerm: ['service_view'] }
        },
        {
          path: 'visitor',
          component: Visitor,
          meta: { requiresPerm: ['service_mgmt', 'service_view'] }
        },
      ]
    },
    {
      path: '/',
      redirect: '/mgmt/home'
    },
    {
      path: '*',
      component: NotFound
    }
  ]
})

function permCheck(to, from, next) {
  let perm = to.meta && to.meta.requiresPerm
  if (perm) {
    let canMgmt = store.state.userInfo.info.perms[perm[0]]
    let canView = perm[1] && store.state.userInfo.info.perms[perm[1]]

    if (!canMgmt && !canView) {
      Message.warning('对不起，您暂未被开通权限')
      next({
        path: from.fullPath
      })
      return
    }
  }
  next()
}

router.beforeEach(async (to, from, next) => {
  let app = router.app

  // set active item in side bar
  store.dispatch(types.sideBar.ACTIVE, to.fullPath)

  if (app._appInited) {
    permCheck(to, from, next)
  } else {
    // 第一次启动的时候执行
    // let retrystaffCheck = makeRetry(api.Auth.staffCheck)

    try {
      let data = await Auth.staffCheck()
      app._appInited = true

      if (data && data.block_id) {
        store.dispatch(types.userInfo.SAVE, data)
        permCheck(to, from, next)
      } else {
        router.replace('/login')
        next()
      }
    } catch (err) {
      Notification.error({
        title: '错误',
        message: err.payload.msg
      })
    }
  }
})

export default router
